import { AppService } from "app/services/app.service";


export abstract class AbAssembleiaItemOpcaoVoto extends AppService {
  abstract getOpsVotoByItemIdId(id: any);
  abstract downloadArquivoItemAssembleiaOpcaoVoto(itemAssembleiaIdOpcaoVoto: number, nomeArquivo: string);
} 